import $ from "jquery";

const {__, _x, _n, _nx} = wp.i18n;

export function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export function toggleCloudCurrency(formSlug) {
    setTimeout(() => {
        const cloudPrices = $(`.gf-${formSlug}__cloud:visible option`);
        const isCurrencyRub = $(`.gf-${formSlug}__currency input`).is(':checked');

        let currency, unit;
        if (ATLEX_OBJ.lang === 'ru' && isCurrencyRub) {
            currency = 'руб/мес.';
            unit = 'ГБ';
        } else if (ATLEX_OBJ.lang === 'ru' && !isCurrencyRub) {
            currency = 'евро/мес.';
            unit = 'ГБ';
        }

        if (ATLEX_OBJ.lang === 'en' && isCurrencyRub) {
            currency = 'rubles/month';
            unit = 'GB';
        } else if (ATLEX_OBJ.lang === 'en' && !isCurrencyRub) {
            currency = 'euro/month.';
            unit = 'GB';
        }

        cloudPrices.each((id, item) => {
            if (isJson($(item).val())) {
                const cloud = JSON.parse($(item).val());
                if (+cloud.price && !isCurrencyRub) {
                    const value = parseFloat(cloud.price / ATLEX_OBJ.exchange_rate.eur).toFixed(2);
                    const label = `${cloud.volume} ${unit} — ${value} ${currency}`;
                    $(item).text(label)
                } else if (+cloud.price && isCurrencyRub) {
                    const label = `${cloud.volume} ${unit} — ${cloud.price} ${currency}`;
                    $(item).text(label)
                }
            }
        })
    }, 1)
}

export function setCurrency(isCurrencyRUB) {
    let currency = isCurrencyRUB ? 'руб.' : 'евро';

    if (ATLEX_OBJ.lang === 'ru' && isCurrencyRUB) {
        currency = 'руб.';
    } else if (ATLEX_OBJ.lang === 'ru' && !isCurrencyRUB) {
        currency = 'евро';
    }

    if (ATLEX_OBJ.lang === 'en' && isCurrencyRUB) {
        currency = 'rubles';
    } else if (ATLEX_OBJ.lang === 'en' && !isCurrencyRUB) {
        currency = 'euro';
    }

    return currency;
}

/**
 * Returns a cookie value if a name is specified. Otherwise returns the entire cookies as an object
 * @param [name] - The name of the cookie to fetch the value for. Returns the entire map of cookies if not specified
 * @returns {string|Object} - The value of the cookie specified by `name` if specified. Otherwise returns a name value map of the available cookies
 */
export function getCookie(name) {
    const cookies = document.cookie.split(';')
        .reduce((acc, cookieString) => {
            const [key, value] = cookieString.split('=').map(s => s.trim());
            if (key && value) {
                acc[key] = decodeURIComponent(value);
            }
            return acc;
        }, {});
    return name ? cookies[name] || '' : cookies;
}

/**
 *
 * @param name - The name of the cookie to be set
 * @param value - The value of the cookie
 * @param options - supports any cookie option like path, expires, maxAge and domain. [MDN Cookie Reference](https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie)
 */
export function setCookie(name, value, options = {}) {
    document.cookie = `${name}=${encodeURIComponent(value)}${
        Object.keys(options)
            .reduce((acc, key) => {
                return acc + `;${key.replace(/([A-Z])/g, $1 => '-' + $1.toLowerCase())}=${
                    options[key]}`;
            }, '')
    }`;
}
